import type { UpdateCueCallback } from '../model/callbacks'
import { useCallback, useState } from 'react'
import type { SettingsState } from '../model/settings-submenu'

export const useOptimisticCueSettings = (
  initialSettings: SettingsState | undefined,
  onUpdateCue: UpdateCueCallback,
) => {
  const [optimisticSettings, setOptimisticSettings] = useState<SettingsState>(
    () => ({
      skipDuringShow: initialSettings?.skipDuringShow ?? false,
      hideOnPdf: initialSettings?.hideOnPdf ?? false,
      hideOnCsv: initialSettings?.hideOnCsv ?? false,
      preventEdits: initialSettings?.preventEdits ?? false,
    }),
  )

  const toggleSetting = useCallback(
    (key: keyof SettingsState) => {
      setOptimisticSettings((prev) => {
        const newValue = !prev?.[key]

        onUpdateCue({
          [`settings.${key}`]: newValue,
        })

        return {
          ...prev,
          [key]: newValue,
        }
      })
    },
    [onUpdateCue],
  )

  return { optimisticSettings, toggleSetting }
}
